export default __webpack_public_path__ + "static/media/home.e3d0e310.md";